module.exports = __webpack_public_path__ + "static/media/Ghost-big.2447f57e.png";